<!-- 发起弹窗 -->
<template>
  <div>
    <el-dialog title="提现" :visible="isShowWithdrawDialog" width="40%" :close-on-click-modal="false" @close="handleDialog">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">

        <el-form-item label="可用金额">
          <el-input size="small" style="width: 180px" type="text" v-model="availableBalance" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="提现币种" prop="fromCurrency">
          <el-select v-model="form.fromCurrency" placeholder="请选择" size="small">
            <el-option v-if="domain == 'api.pay-pakistan.com'" label="PKR" value="PKR"></el-option>
            <el-option v-else label="BRL" value="BRL"></el-option>
            <!-- <el-option label="USDT" value="USDT"></el-option> -->
          </el-select>
        </el-form-item>

        <el-form-item label="提现金额" prop="amount" v-if="form.fromCurrency == 'BRL'">
          <el-input size="small" style="width: 180px" type="text" v-model="form.amount" placeholder="请输入提现金额"></el-input>
        </el-form-item>
        <el-form-item label="提币数量" prop="fromAmount" v-if="form.fromCurrency == 'USDT'">
          <el-input size="small" style="width: 180px" type="text" v-model="form.fromAmount" placeholder="请输入提币数量"></el-input>
        </el-form-item>

        <el-form-item label="提现汇率" prop="exchangeRate">
          <el-input width="10px" style="width: 200px" size="small" type="text" v-model="form.exchangeRate" placeholder="以管理员填写为准"
            show-word-limit maxlength="5"></el-input>
        </el-form-item>

        <el-form-item label="接收账号" prop="collectAccount">
          <el-input size="small" type="text" v-model="form.collectAccount" placeholder="请输入42位USDT接收地址" show-word-limit
            maxlength="42"></el-input>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input size="small" type="textarea" v-model="form.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialog">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    isShowWithdrawDialog: {
      type: Boolean,
      default: false,
    },
    balance: {
      type: Number | String,
      default: 0,
    },
    freezeBalance: {
      type: Number | String,
      default: 0,
    },
    availableBalance: {
      type: Number | String,
      default: 0,
    },
  },
  data() {
    return {
      form: {
        type: '01',
        amount: '',
        fromAmount: '',
        collectAccount: '',
        exchangeRate: '',
        remark: '',
        fromCurrency: 'BRL'
      },
      rules: {
        fromCurrency: [
          { required: true, message: '请选择提现类型', trigger: 'change' },
        ],

        amount: [
          { required: true, validator: this.validateAmount, trigger: 'blur' },
        ],
        fromAmount: [
          { required: true, message: '请输入提币数量', trigger: 'blur' },
        ],
        exchangeRate: [
          { required: true, message: '请输入参考汇率', trigger: 'blur' },
        ],
        collectAccount: [
          { required: true, message: '请输入42位账号', trigger: 'blur' },
          { min: 34, max: 42, message: '请输入42位账号', trigger: 'blur' },
        ],
      },
      domain: document.domain,
    }
  },
  methods: {
    validateAmount(rule, value, callback) {
      var submitAmount = parseFloat(value)
      if (isNaN(submitAmount) || submitAmount <= 0) {
        callback(new Error('请输入提现金额'))
      } else {
        var avBla = parseFloat(this.availableBalance)
        if (avBla < submitAmount) {
          callback(new Error('提现金额不能大于可用余额，请重新输入'))
        } else {
          callback()
        }
      }
    },
    handleDialog() {
      this.$refs['form'].resetFields()
      this.form = {
        type: '01',
        amount: '',
        fromAmount: '',
        collectAccount: '',
        exchangeRate: '',
        remark: '',
        fromCurrency: 'BRL'
      }
      this.$emit('update:isShowWithdrawDialog', false)
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          let params = {}
          if (this.form.fromCurrency == 'BRL') {
            params = {
              type: this.form.type,
              amount: this.form.amount,
              collectAccount: this.form.collectAccount,
              remark: this.form.remark,
              fromCurrency: this.form.fromCurrency,
              exchangeRate: this.form.exchangeRate
            }
          } else {
            params = {
              type: this.form.type,
              fromAmount: this.form.fromAmount,
              collectAccount: this.form.collectAccount,
              remark: this.form.remark,
              fromCurrency: this.form.fromCurrency,
              exchangeRate: this.form.exchangeRate
            }
          }
          this.$axios
            .post('/depositWithdraw/addDepositWithdraw', params)
            .then(res => {
              if (res.code === 200) {
                this.$notify({
                  title: '提示',
                  message: res.msg,
                  type: 'success',
                })
                this.$emit('update:isShowWithdrawDialog', false)
                this.$bus.$emit('refresh') //通知刷新
              } else {
                this.$notify.error({
                  title: '提示',
                  message: res.msg,
                })
              }
            })
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #e4e7ed;
}
</style>